






import { Component, Vue, Prop } from 'vue-property-decorator';
import { Ingredient, Recipe } from '@/api';

import RecipesTable from '@/components/dashboard/RecipesTable.vue';

@Component({
  components: { RecipesTable },
})
export default class IngredientRecipes extends Vue {
  @Prop({ required: true }) readonly item: Ingredient;

  get scopeFactory() {
    return () =>
      Recipe.includes('recipeTags.tag')
        .order({ modified: 'desc' })
        .where({
          is_newest: true,
          uses_ingredient: this.item.coreId,
        });
  }
}
